<template>
  <section
    v-if="!welcomeDisplayed"
    class="cont-fullwidth"
    style="overflow: hidden !important;"
  >
    <div class="row d-flex align-content-center">
      <div
        class="col-12 d-flex align-items-center justify-content-center vh-100"
      >
        <div class="innerpadding-30 w-600">
          <h2 class="blue-text onboard space-grot-reg">Welcome</h2>
          <h1 class="space-grot-bold mt-0 mb-2 onboard">
            Let's play...
            <div class="purple-text">{{ eventName }}</div>
          </h1>
          <button
            class="btn-blue-form mb-2"
            type="button"
            @click="getStartedClicked"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  </section>
  <section
    v-else-if="welcomeDisplayed && !videoDisplayed"
    class="cont-fullwidth"
    style="overflow: hidden !important;"
  >
    <header
      style="position: fixed; top: -15px; padding: 15px 15px 15px 15px; left: 0; border-bottom: 1px solid white; width: 100% !important; z-index: 1;"
    >
      <h2 class="white-text onboard">{{ eventName }}</h2>
    </header>

    <section
      class="cont-fullwidth"
      style="overflow: hidden !important; padding-top: 70px;"
    >
      <div class="row d-flex align-content-center">
        <div
          class="col-12 d-flex align-items-center justify-content-center video-mobile-fix"
        >
          <div class="innerpadding-30 w-video">
            <div class="embed-container hidden-mobile">
              <iframe
                ref="desktopVimeo"
                src=""
                class="hidden-mobile"
                width="640"
                height="360"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>
            <iframe
              ref="mobileVimeo"
              src=""
              class="visible-mobile"
              width="100%"
              height="360"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>

    <nav id="intro-nav">
      <button
        v-if="showNextButton"
        class="btn-black-form mb-2 w-600"
        type="button"
        @click="nextClicked"
      >
        Next
      </button>
      <button
        v-else
        id="buttonWait"
        class="btn-black-form mb-2 w-600"
        type="button"
        @dblclick="nextClicked"
      >
        Please watch til the end
      </button>
    </nav>
  </section>
  <section v-else>
    <header
      style="position: fixed; top: -15px; padding: 15px 15px 15px 15px; left: 0; border-bottom: 1px solid #AB4FF4; width: 100% !important; z-index: 1;"
    >
      <h2 class="purple-text onboard">{{ eventName }}</h2>
    </header>

    <section
      class="cont-fullwidth"
      style="overflow: hidden !important; padding-top: 70px;padding-bottom: 120px;height: 90vh !important;"
    >
      <div class="row d-flex align-content-center">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div
            class="innerpadding-30 w-600 display-scrollbar"
            style="height: 90vh !important; overflow: scroll; padding-bottom: 130px;"
          >
            <h2 class="mt-0 mb-1 purple-text onboard">Join a team</h2>
            <h2 class="mt-0 pt-0 mb-2 onboard">
              Teams will appear below as they are created, so simply wait to see
              your team appear below or create a new one.
            </h2>

            <section>
              <div
                style="curos"
                v-for="(team, index) in orderedTeams"
                :key="'team_' + index"
                class="team-box white-text-team"
                :class="[
                  {
                    active: activeTeamId === team.id
                  },
                  { 'd-flex': activeTeamId === team.id },
                  { 'align-items-center': activeTeamId === team.id }
                ]"
                @click="activeTeamId = team.id"
              >
                <div class="team-inner">
                  <div class="join">Join</div>
                  <h2 class="pb-0 mb-0 mt-0 space-grot-bold onboard">
                    {{ team.teamName }}
                  </h2>

                  <div
                    class="join-detail w-600"
                    :style="[
                      {
                        display: activeTeamId === team.id ? 'block' : 'none'
                      }
                    ]"
                  >
                    <input
                      type="text"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="form-item-login mb-2"
                      placeholder="Enter your name here"
                      aria-label="Answer here"
                      v-model="teamMemberName"
                      @keyup.enter="
                        if (newMemberDataValid && !awaitingServerResponse) {
                          awaitingServerResponse = true
                          submitJoinTeam(team)
                        }
                      "
                    />
                    <button
                      class="btn-orange-join mb-0"
                      type="button"
                      @click="
                        if (newMemberDataValid && !awaitingServerResponse) {
                          awaitingServerResponse = true
                          submitJoinTeam(team)
                        }
                      "
                    >
                      Join Team
                      <span
                        v-if="awaitingServerResponse"
                        class="button-loading-spinner"
                      ></span>
                    </button>
                    <div
                      class="closeActive"
                      v-on:click.stop="activeTeamId = null"
                    >
                      Back to Teams List
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <nav id="team-nav" :class="{ 'create-active': createTeamActive }">
      <div
        id="create-a-team"
        :class="{
          'create-a-team-inactive': !createTeamActive,
          'create-a-team-active': createTeamActive,
          'd-flex': createTeamActive,
          'align-items-center': createTeamActive,
          'btn-purple-form': !createTeamActive
        }"
        class=" mb-2 w-600 create-a-team"
        @click="
          teamCreatedSuccessfully = false
          createTeamActive = true
          teamName = ''
        "
      >
        <div class="btn-title">Create a team</div>
        <div class="create-a-team-info w-600">
          <h2 class="mt-0 space-grot-bold onboard blue-text">Create a team</h2>

          <input
            type="text"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            class="form-item-login mb-2"
            placeholder="Enter your team name"
            aria-label="Answer here"
            v-model="teamName"
            @keyup.enter="
              if (newTeamDataValid && !awaitingServerResponse) {
                awaitingServerResponse = true
                submitNewTeamName()
              }
            "
          />
          <div v-if="teamCreationError">{{ teamCreationError }}</div>
          <div
            class="btn-purple-form mb-0"
            style="width: 100% !important; cursor: pointer;"
            v-on:click.stop="
              if (newTeamDataValid && !awaitingServerResponse) {
                awaitingServerResponse = true
                submitNewTeamName()
              }
            "
          >
            Add team
            <span
              v-if="awaitingServerResponse"
              class="button-loading-spinner"
            ></span>
          </div>

          <div
            class="closeCreate blue-text"
            v-on:click.stop="
              if (!awaitingServerResponse) {
                teamCreationError = null
                createTeamActive = false
              }
            "
          >
            Back to Teams List
          </div>
        </div>
      </div>
    </nav>
  </section>
</template>
<script>
export default {
  props: {
    code: String,
    eventName: String,
    teams: Array
  },
  data: () => ({
    teamName: '',
    selectedTeam: null,
    activeTeamId: null,
    createTeamActive: false,
    welcomeDisplayed: false,
    videoDisplayed: false,
    teamMemberName: null,
    awaitingServerResponse: false,
    teamCreationError: null,
    teamCreatedSuccessfully: false,
    player: null,
    showNextButton: false
  }),
  created() {
    document.body.classList.remove('purple-bg')
  },
  mounted() {},
  computed: {
    orderedTeams() {
      return this.teams.slice().sort((a, b) =>
        a.teamName
          .trim()
          .toLowerCase()
          .localeCompare(b.teamName.trim().toLowerCase(), 'en', {
            numeric: true
          })
      )
    },
    newMemberDataValid() {
      return !(this.teamMemberName === null || this.teamMemberName.length === 0)
    },
    newTeamDataValid() {
      return !(this.teamName === null || this.teamName.length === 0)
    }
  },
  methods: {
    setupVimeoVideos() {
      const desktopVideoSource =
        'https://player.vimeo.com/video/665963796?h=d243e8945b&amp;autoplay=1&amp;controls=1&amp;badge=0'
      const mobileVideoSource =
        'https://player.vimeo.com/video/667261723?h=864f5dc341&amp;autoplay=1&amp;controls=1&amp;badge=0'

      const desktopVimeoIFrame = this.$refs.desktopVimeo
      const mobileVimeoIFrame = this.$refs.mobileVimeo

      const desktopVimeoDisplay = window
        .getComputedStyle(desktopVimeoIFrame, null)
        .getPropertyValue('display')

      if (desktopVimeoDisplay !== 'none') {
        desktopVimeoIFrame.src = desktopVideoSource
        mobileVimeoIFrame.src = ''
      } else {
        mobileVimeoIFrame.src = mobileVideoSource
        desktopVimeoIFrame.src = ''
      }
    },
    getStartedClicked() {
      this.welcomeDisplayed = true

      document.body.classList.add('purple-bg')

      this.$nextTick(function() {
        this.setupVimeoVideos()
      })

      setTimeout(() => {
        this.showNextButton = true
      }, 20000)
    },
    nextClicked() {
      this.videoDisplayed = true
      document.body.classList.remove('purple-bg')
    },
    teamClicked(event) {
      console.log('Clicked:', event.target)
      console.log('Binding is on:', event.currentTarget)
    },
    submitJoinTeam(team) {
      this.selectExistingTeam(team.id, team.teamName, this.teamMemberName)
    },
    submitNewTeamName() {
      this.$emit('submitNewTeamName', {
        teamName: this.teamName,
        success: () => {
          this.awaitingServerResponse = false
          this.createTeamActive = false
          this.teamCreationError = null
        },
        error: message => {
          console.log(`Error submitting new team name: ${message}`)

          this.awaitingServerResponse = false
          this.teamCreationError = message
        }
      })
    },
    refreshTeamList() {
      this.$emit('refreshTeamList')
    },
    selectExistingTeam(teamId, teamName, fullName) {
      console.log(`selectExistingTeam: ${teamId}, ${teamName}, ${fullName}`)

      this.$emit('submitSelectTeamAndAddMember', teamId, teamName, fullName)
    },
    submitExistingTeam() {
      if (this.selectedTeam === null) {
        return
      }

      this.$emit(
        'submitSelectTeam',
        this.selectedTeam.id,
        this.selectedTeam.teamName
      )
    }
  }
}
</script>
